'use client';

import Link from 'next/link';
import DataObjectIcon from '@mui/icons-material/DataObject';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useTheme } from '../contexts/ThemeContext';

interface NavigationProps {
    activePage?: 'home' | 'docs' | 'examples' | 'operations' | 'diff';
}

export default function Navigation({ activePage = 'home' }: NavigationProps) {
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <header className="app-header">
            <div className="nav-container">
                {/* Logo */}
                <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <DataObjectIcon style={{ color: 'var(--accent)', fontSize: '28px' }} />
                    <span className="nav-logo">
                        JSON Patch
                    </span>
                </Link>

                {/* Nav Links + Theme Toggle */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <nav className="desktop-only-nav" style={{ display: 'flex', gap: '4px' }}>
                        <Link href="/docs" className={`nav-link ${activePage === 'docs' ? 'active' : ''}`}>
                            Docs
                        </Link>
                        <Link href="/examples" className={`nav-link ${activePage === 'examples' ? 'active' : ''}`}>
                            Examples
                        </Link>
                        <Link href="/diff" className={`nav-link ${activePage === 'diff' ? 'active' : ''}`}>
                            Diff
                        </Link>
                    </nav>

                    <button
                        onClick={toggleTheme}
                        className="theme-toggle-btn"
                        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                    >
                        {isDarkMode ? <LightModeOutlinedIcon style={{ fontSize: '20px' }} /> : <DarkModeOutlinedIcon style={{ fontSize: '20px' }} />}
                    </button>
                </div>
            </div>
        </header>
    );
}
